module.exports = __webpack_public_path__ + "img/battle_section3_title.bdea110f.png";